export const PAGINATION_LIMIT = 10000;

export const DEFAULT_DESCRIPTION =
  'Monetary and financial issues are not as difficult as they often are. But not knowing can be expensive. Sign up for a course - whether you are interested in stocks or new technologies such as Blockchain. With our learning controls you can test yourself how well you already know.';
